import { t } from '../../../adapters/translate/translate'
import { customTheme } from '../../../styles/theme'
import HelpForm from '../../help-form'
import { AlertBox } from '../../ui/layout'
import {
  ModalDialogBody, ModalDialogClose,
  ModalDialogContent,
  ModalDialogHeader, ModalDialogHeaderTitle,
  ModalDialogOverlay
} from './modal_box_styled'

const HelpModal = ({ handleClose, isAnonymous }: any) => {
  return (
    <>
      <ModalDialogOverlay onClick={handleClose} />
      <ModalDialogContent>
        <ModalDialogHeader background={customTheme.colors.gray[300]}>
          <ModalDialogHeaderTitle>{t('Send us a message')}</ModalDialogHeaderTitle>
          <ModalDialogClose onClick={handleClose}>&times;</ModalDialogClose>
        </ModalDialogHeader>
        <ModalDialogBody>
          <HelpForm isAnonymous={isAnonymous} handleClose={handleClose}/>
        </ModalDialogBody>
      </ModalDialogContent>
      <AlertBox />
    </>
  )
}

export default HelpModal
